'use client';

import { LinkButton } from '@/components/ui/Button/LinkButton';
import { errorBrandConfig } from '@/lib/error/brandConfig';
import { captureError } from '@/lib/errors';
import { devError } from '@/lib/utils/devLog';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import styles from './error.module.scss';

export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
  const t = useTranslations('errors.serverErrorPage');
  const config = errorBrandConfig;

  useEffect(() => {
    devError('[Page Error]', error.message, error.digest);

    // Server-rendering errors are already reported by onRequestError.
    if (!error.digest) {
      captureError(error, { tags: { source: 'page-error' } });
    }
  }, [error]);

  return (
    <div role="alert" className={styles.container} data-error-page>
      <h1 className={styles.title}>{t('title')}</h1>
      <h2 className={styles.subtitle}>{t('subtitle')}</h2>
      <p className={styles.description}>
        {t('description', { email: config.email, website: config.website })}
      </p>
      <LinkButton href="/" variant="outline" size="md">
        {t('backToBrand', { brand: config.name })}
      </LinkButton>
    </div>
  );
}
